import React, { useState, Suspense } from "react";
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";
import { request } from "../sites/request";
import { EtudesTable } from "./EtudesTable";
import { EtudeResultTable } from "./EtudeResultTable";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { ErrorBoundary } from "commons";
import { Loader } from "../sites/Loader";
import { Button } from "reactstrap";
import { RiAddCircleLine } from "react-icons/ri";
import { EtudeCreateModal } from "./EtudeCreateModal";

const useEtudes = () => {
  const { data, isFetching, isLoading } = useQuery(["etudes"], () =>
    request({
      url: "etudes",
      method: "GET",
    }),
  );

  return { data, isFetching, isLoading };
};

const useEtudeDetails = (studyId) => {
  const { data, isFetching, isLoading } = useQuery(
    ["etudeDetails", studyId],
    () => {
      if (!studyId) {
        return Promise.resolve(null);
      }

      return request({
        url: `etudes/${studyId}`,
        method: "GET",
      });
    },
    {
      enabled: !!studyId,

      refetchOnWindowFocus: false,
      retry: false,
    },
  );

  return { data, isFetching, isLoading };
};

export const Etudes = () => {
  const [selectedStudyId, setSelectedStudyId] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const { t } = useTranslation();

  const { data: studies, isFetching, isLoading } = useEtudes();
  const { data: studyDetails, isFetching: isDetailsFetching } = useEtudeDetails(
    selectedStudyId,
  );

  const handleRowClick = (id) => {
    setSelectedStudyId(id);
  };

  const toggleModal = (value) => () =>
    setOpenModal((isOpen) => (value === null ? !isOpen : true));

  return (
    <>
      <div
        css={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "1rem",
          button: {
            marginLeft: "1rem",
            svg: {
              transform: "scale(1.4) translateY(-1px)",
              marginRight: "0.8rem",
            },
          },
        }}
      >
        <Button
          style={{ color: "black", background: "#98D2DD", border: "#98D2DD" }}
          onClick={toggleModal(null)}
        >
          <RiAddCircleLine />
          {t("etudes.creation.create")}
        </Button>
      </div>
      <div className="content-area">
        <EtudesTable
          studies={studies}
          isFetching={false}
          onRowClick={handleRowClick}
          selectedStudyId={selectedStudyId}
        />

        <Modal
          isOpen={openModal}
          fade={true}
          toggle={toggleModal(null)}
          css={{
            maxWidth: 1100,
            ".modal-body": {
              maxHeight: "75vh",
              overflow: "auto",
            },
          }}
        >
          <ModalHeader toggle={toggleModal(null)}>
            {t("etudes.creation.title")}
          </ModalHeader>
          <ModalBody>
            <ErrorBoundary>
              <Suspense fallback={<Loader />}>
                <EtudeCreateModal />
              </Suspense>
            </ErrorBoundary>
          </ModalBody>
        </Modal>

        {selectedStudyId && (
          <div style={{ marginTop: "50px" }}>
            <EtudeResultTable
              study={studyDetails}
              isFetching={isDetailsFetching}
            />
          </div>
        )}
      </div>
    </>
  );
};
